import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';

function Worlds() {
    return (
        <>
        <Header/>
        <Footer/>
        </>
    )
}

export default Worlds;